export const filters = {
    cityId: [null],
    jobPositionId: [null],
    workTimeId: [null],
    workPlaceId: [null]
}